import React from 'react'
import styled from 'styled-components'
import CajaVotacion from '@/components/CajaVotacion'

const StVotoInfo = styled.div`
  strong {
    text-transform: capitalize;
  }
  .votoblock {
  }
`

const VotacionInfo = ({ info }) => {
  if (!info) return false
  const {
    circunscripcion_electoral,
    comuna,
    comuna_apruebo,
    comuna_rechazo,
    local,
    mesa,
    mesa_apruebo,
    mesa_fusionada,
    mesa_rechazo,
    participacion,
    region,
    region_apruebo,
    region_rechazo,
  } = info

  const low = str => {
    return str.toLowerCase()
  }

  return (
    <StVotoInfo>
      <CajaVotacion apruebo={mesa_apruebo} rechazo={mesa_rechazo}>
        <h2 className="leading-none">
          Tu mesa, <strong>{mesa}</strong> en <strong>{low(local)}</strong>...
        </h2>
      </CajaVotacion>
      <CajaVotacion apruebo={comuna_apruebo} rechazo={comuna_rechazo}>
        <h2 className="leading-none">
          Tu comuna, <strong>{low(comuna)}</strong>...
        </h2>
      </CajaVotacion>
      <CajaVotacion apruebo={region_apruebo} rechazo={region_rechazo}>
        <h2 className="leading-none">
          Tu región, <strong>{low(region)}</strong>...
        </h2>
      </CajaVotacion>
    </StVotoInfo>
  )
}

export default VotacionInfo
